// Ubicación en el repo: src/components/AdjustStockModal.jsx
// "Ajustar stock" — mismo contenido que adjustStockPrompt() del
// prototipo (línea ~3029): se indica el total nuevo directamente, no un
// delta. Pensado para el caso rápido de "llegó mercadería nueva" sin
// tener que abrir el formulario completo de edición.
//
// Fase B (migración 0049, 25-ago-2026): `item.stock` ya viene acotado a la
// sucursal activa (ver listCatalog({ branchId }) en lib/catalog.js) — el
// ajuste que se guarda acá es SOLO para esa sucursal (`setBranchStock`),
// no un número global. Si el producto está en varias sucursales, cada una
// se ajusta por separado, entrando a esa sucursal primero.
import { useState } from 'react';
import { setBranchStock } from '../lib/catalog';

export default function AdjustStockModal({ item, branchId, branchName, onClose, onSaved }) {
  const [stock, setStock] = useState(String(item.stock ?? 0));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      await setBranchStock(item.id, branchId, stock);
      onSaved();
    } catch (err) {
      setError(err.message || 'No se pudo ajustar el stock.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>
          Ajustar stock · {item.brand} {item.model}
        </h2>
        <p className="field-hint" style={{ marginTop: -6 }}>
          Stock actual en <strong>{branchName || 'esta sucursal'}</strong>:{' '}
          <strong>{Number(item.stock || 0)}</strong> unidades.
        </p>

        <form onSubmit={handleSubmit} className="patient-form">
          <label className="field">
            <span>Nueva cantidad total</span>
            <input type="number" min="0" value={stock} onChange={(e) => setStock(e.target.value)} autoFocus />
          </label>

          {error && <p className="auth-error">{error}</p>}

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="button-primary" disabled={saving}>
              {saving ? 'Guardando…' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
